export default __webpack_public_path__ + "images/ZJ.bc726ec.png";